import Vue from 'vue'

export const BTN_PERMS_TYPE = {
    // 账号管理
    account: {
        add: 'system:account:add',
        update: 'system:account:update',
        delete: 'system:account:delete',
        view: 'system:account:view'
    },
    // 菜单管理
    menu: {
        add: 'system:menu:add',
        update: 'system:menu:update',
        delete: 'system:menu:delete',
        view: 'system:menu:view'
    },
    // 角色管理
    role: {
        add: 'system:role:add',
        update: 'system:role:update',
        delete: 'system:role:delete',
        view: 'system:role:view'
    },
    // 部门管理
    dept: {
        add: 'system:dept:add',
        update: 'system:dept:update',
        delete: 'system:dept:delete',
        view: 'system:dept:view'
    },
    ticket: {
        // 票据入库
        in: {
            add: 'ticket:in:add',
            update: 'ticket:in:update',
            delete: 'ticket:in:delete',
            view: 'ticket:in:view',
            export: 'ticket:in:export'
        },
        // 票据出库
        out: {
            add: 'ticket:out:add',
            update: 'ticket:out:update',
            delete: 'ticket:out:delete',
            view: 'ticket:out:view',
            export: 'ticket:out:export',
            outCustomerName: 'ticket:out:outCustomerName'
        }

    },
    // 客户管理
    client: {
        add: 'ticket:client:add',
        update: 'ticket:client:update',
        delete: 'ticket:client:delete',
        view: 'ticket:client:view'
    },
    // 对账管理
    check: {
        add: 'ticket:check:add',
        update: 'ticket:check:update',
        delete: 'ticket:check:delete',
        view: 'ticket:check:view',
        export: 'ticket:check:export',
        import: 'ticket:check:import',
        rollback: 'ticket:check:rollback',
    },
    // 应收应付
    bill: {
        add: 'ticket:bill:add',
        update: 'ticket:bill:update',
        delete: 'ticket:bill:delete',
        view: 'ticket:bill:view'
    },
    // 票据拟售价
    estimate: {
        add: 'ticket:estimate:add',
        update: 'ticket:estimate:update',
        delete: 'ticket:estimate:delete',
        view: 'ticket:estimate:view'
    },
    // 线下入库
    offline: {
        add: 'ticket:offline:add',
        update: 'ticket:offline:update',
        delete: 'ticket:offline:delete',
        view: 'ticket:offline:view',
        export: 'ticket:offline:export'
    }
}

Vue.directive('hasPerm', {
    inserted: (el, binding, vnode) => {
        const btnPerms = vnode.context.$store.getters.getBtnPerms(binding.value)
        if (btnPerms === undefined || btnPerms === null) {
            el.parentNode.removeChild(el)
        }
    }
})


// WEBPACK FOOTER //
// ./src/utils/permissions.js